import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
/**
 * The brand of the authenticated user, if applicable.
 */ export var getBrand = function() {
    return getGlobalProperty("brand");
};
